// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3aVoj","header":"MessagesList_header__2vEx2","chat":"MessagesList_chat__1BwVk"};